define('home/models/Post',[
    'jquery',
    'underscore',

    'core/models/Post',

    'core/UniqueModel',
    'home/models/Thread',
    'home/models/User',
    'home/collections/UpvotersUserCollection',
], function (
    $,
    _,

    CorePost,

    UniqueModel,
    Thread,
    User,
    UpvotersUserCollection
) {
    'use strict';

    var parent = CorePost;
    var parentProto = parent.prototype;


    var Post = CorePost.extend({

        // TODO: unify Home's UpvotersUserCollection with embed's
        upvotersCollectionClass: UpvotersUserCollection,

        initialize: function (attrs, options) {
            parentProto.initialize.call(this, attrs, options);

            this.set({ state: this._getPostState() });
            this.initializeRelated(
                'thread',
                _.extend({ forum: attrs.forum }, options),
                Thread
            );

            // this.author is set via the Post.withAuthor mixin from next-core
        },

        toJSON: function () {
            var stringifiable = parentProto.toJSON.apply(this, arguments);
            stringifiable.thread = this.thread.toJSON();
            return stringifiable;
        },

        getLinks: _.memoize(function () {
            var $wrapper = $('<div>').html(this.get('message'));
            return $wrapper.find('a[href]').map(function (__, el) {
                return $(el).attr('href');
            });
        }, function () {
            return this.id;
        }),

        getThreadId: function () {
            return this.thread.id;
        },

        _getPostState: function () {
            if (this.get('isSpam'))
                return 'spam';

            if (this.get('isDeleted'))
                return 'deleted';

            // Once a post is flagged to over the site flag threshold it is unapproved
            // Flagged + approved means it's still visible
            if (this.get('isFlagged') && !this.get('isApproved'))
                return 'flagged';

            if (!this.get('isApproved'))
                return 'pending';

            return 'visible';
        },
    });

    CorePost.withAuthor.call(Post.prototype, UniqueModel.boundModel(User));

    // TODO - apply Post.withMediaCollection mixin

    UniqueModel.addType('Post', Post);

    return Post;
});

